export const ORIGIN_POINT = { x: 0, y: 0 };
export const MINIMUM_COORD_VALUE = 0.5;
export const DEFAULT_ZOOM = 1;
